import React from "react"
import { Helmet } from "react-helmet"
import "../../styles/BuyButton.css"

export default function BuyButton({ productId, componentId, price }) {
  return (
    <>
      <div id={`product-component-${componentId}`}></div>
      <Helmet>
        <script>
          {`
            (function () {
              var scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
              if (window.ShopifyBuy) {
                if (window.ShopifyBuy.UI) {
                  ShopifyBuyInit();
                } else {
                  loadScript();
                }
              } else {
                loadScript();
              }
              function loadScript() {
                var script = document.createElement('script');
                script.async = true;
                script.src = scriptURL;
                (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
                script.onload = ShopifyBuyInit;
              }
              function ShopifyBuyInit() {
                var client = ShopifyBuy.buildClient({
                  domain: 'the-adventure-guild.myshopify.com',
                  storefrontAccessToken: '9b078a0ce943a4e57763da4e5101a507',
                });
                ShopifyBuy.UI.onReady(client).then(function (ui) {
                  ui.createComponent('product', {
                    id: '${productId}',
                    node: document.getElementById('product-component-${componentId}'),
                    moneyFormat: '%24%7B%7Bamount%7D%7D',
                    options: {
                      "product": {
                        iframe: false,
                        "contents": {
                          "img": false,
                          "title": false,
                          "price": false
                        },
                        "text": {
                          "button": "Add to Cart • $${price}"
                        }
                      },
                      "cart": {
                        "styles": {
                          "button": {
                            "font-size": "20px",
                            "font-weight": "700",
                            "padding-top": "16px",
                            "padding-bottom": "16px",
                            "padding-left": "32px",
                            "padding-right": "32px",
                            "border-radius": "0px",
                            "width": "100%",
                            "background-color": "#fff",
                            "color": "#000",
                            ":hover": {
                              "background-color": "#ddd"
                            },
                            ":focus": {
                              "background-color": "#ddd"
                            }
                          },
                          "title": {
                            "color": "#fff",
                            "font-size": "28px",
                            "font-weight": "700"
                          },
                          "header": {
                            "color": "#fff"
                          },
                          "lineItems": {
                            "color": "#fff",
                          },
                          "subtotalText": {
                            "color": "#fff",
                            "font-size": "20px",
                            "font-weight": "400",
                            "text-transform": "capitalize"
                          },
                          "subtotal": {
                            "color": "#fff",
                            "font-size": "20px",
                            "font-weight": "700"
                          },
                          "notice": {
                            "color": "#fff"
                          },
                          "currency": {
                            "color": "#fff"
                          },
                          "close": {
                            "color": "#fff",
                            ":hover": {
                              "color": "#fff"
                            }
                          },
                          "empty": {
                            "color": "#fff"
                          },
                          "noteDescription": {
                            "color": "#fff"
                          },
                          "discountText": {
                            "color": "#fff"
                          },
                          "discountIcon": {
                            "fill": "#fff"
                          },
                          "discountAmount": {
                            "color": "#fff"
                          },
                          "cart": {
                            "background-color": "#000"
                          },
                          "footer": {
                            "background-color": "#000",
                            "border-top": "1px solid #999"
                          }
                        },
                        "text": {
                          "total": "Subtotal",
                          "button": "Checkout"
                        },
                        "popup": false
                      },
                      "toggle": {
                        "styles": {
                          "toggle": {
                            "background-color": "#000",
                            "border-top": "1px solid #444",
                            "border-left": "1px solid #444",
                            "border-bottom": "1px solid #444",
                            "border-radius": "0px",
                            ":hover": {
                              "background-color": "#222"
                            },
                            ":focus": {
                              "background-color": "#222"
                            }
                          },
                          "count": {
                            "font-size": "18px",
                            "font-weight": "400"
                          }
                        }
                      },
                      "lineItem": {
                        "styles": {
                          "variantTitle": {
                            "color": "#fff"
                          },
                          "title": {
                            "color": "#fff"
                          },
                          "price": {
                            "color": "#fff"
                          },
                          "fullPrice": {
                            "color": "#fff"
                          },
                          "discount": {
                            "color": "#fff"
                          },
                          "discountIcon": {
                            "fill": "#fff"
                          },
                          "quantity": {
                            "color": "#fff"
                          },
                          "quantityIncrement": {
                            "color": "#fff",
                            "border-color": "#fff"
                          },
                          "quantityDecrement": {
                            "color": "#fff",
                            "border-color": "#fff"
                          },
                          "quantityInput": {
                            "color": "#fff",
                            "border-color": "#fff"
                          }
                        }
                      }
                    },
                  });
                });
              }
            })();
          `}
        </script>
      </Helmet>
    </>
  )
}


